import axios from 'axios';
import { TInfoBox } from '../types/ExtInfoBox';

/**
 * 情報管理データ取得(詳細データ)
 */
export const getExtInfoBoxes = (targetId: number, type: number) => {
  return axios
    .get(`/api/v1/get/ext_info_boxes?target_id=${targetId}&type=${type}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getExtInfo = (targetIds: number[], type: number) => {
  return axios
    .post(
      '/api/v1/get/ext_info',
      {
        target_ids: targetIds,
        type: type
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateExtInfoBoxes = (
  data: TInfoBox[],
  targetId: number,
  type: number
) => {
  const requestData = {
    target_id: targetId,
    data: data,
    type: type
  };

  return axios
    .post('/api/v1/update/ext_info_boxes', requestData, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
